// src/shared/layouts/AppLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '@shared/components/Header';
import TopNavigation from '@shared/components/TopNavigation';

const AppLayout: React.FC = () => {
  return (
    <div className="app-shell min-h-screen min-w-0 bg-gray-50" dir="rtl">
      {/* Header - Fixed at top */}
      <Header />
      
      {/* Top Navigation with Breadcrumbs - Sticky below header */}
      <TopNavigation />
      
      {/* Main Content Area */}
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="app-main min-w-0"
      >
        <div className="app-content min-w-0 p-2 pb-24 sm:p-4 sm:pb-24 2xl:p-6 2xl:pb-24">
          <Outlet />
        </div>
      </motion.main>
    </div>
  );
};

export default AppLayout;

